"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPostMessageToDrillablePredicates = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
/**
 * Converts post message with drilling specification into header predicates. Given the message with
 * uris, identifiers and composedFrom uris and identifiers, this function will create instances of
 * uriMatch(), identifierMatch(), composedFromUri(), composedFromIdentifier() predicates.
 *
 * @param postMessageData - input received via post message
 * @internal
 */
function convertPostMessageToDrillablePredicates(postMessageData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var uris, identifiers, composedFrom, simpleUris, simpleIdentifiers, composedFromUris, composedFromIdentifiers;
        return tslib_1.__generator(this, function (_a) {
            uris = postMessageData.uris, identifiers = postMessageData.identifiers, composedFrom = postMessageData.composedFrom;
            simpleUris = isArray_1.default(uris) ? uniq_1.default(uris) : [];
            simpleIdentifiers = isArray_1.default(identifiers) ? uniq_1.default(identifiers) : [];
            composedFromUris = (composedFrom === null || composedFrom === void 0 ? void 0 : composedFrom.uris) && isArray_1.default(composedFrom.uris) ? uniq_1.default(composedFrom.uris) : [];
            composedFromIdentifiers = (composedFrom === null || composedFrom === void 0 ? void 0 : composedFrom.identifiers) && isArray_1.default(composedFrom.identifiers) ? uniq_1.default(composedFrom.identifiers) : [];
            // note: not passing factory function to maps to make testing assertions simpler (passing factory fun-as-is
            //  will call the factory with 3 args (value, index and all values)
            return [2 /*return*/, tslib_1.__spreadArrays(simpleUris.map(function (uri) { return sdk_ui_1.HeaderPredicates.uriMatch(uri); }), simpleIdentifiers.map(function (identifier) { return sdk_ui_1.HeaderPredicates.identifierMatch(identifier); }), composedFromUris.map(function (uri) { return sdk_ui_1.HeaderPredicates.composedFromUri(uri); }), composedFromIdentifiers.map(function (identifier) { return sdk_ui_1.HeaderPredicates.composedFromIdentifier(identifier); }))];
        });
    });
}
exports.convertPostMessageToDrillablePredicates = convertPostMessageToDrillablePredicates;
//# sourceMappingURL=drillablePredicates.js.map